import initialState from './generalInitialState';
import mutations from './generalMutation';
import actions from './generalAction';

const getters = {
  statesOptions: (state) => {
    const {
      states,
    } = state;
    return states.map(s => ({
      label: s.state,
      value: s.abbreviation,
    }));
  },
};

const generalModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default generalModule;
